import {
	Component,
	ComponentInterface,
	EventEmitter,
	Event,
	h,
	Prop,
	Method,
	Listen,
} from '@stencil/core';

@Component({
	tag: 'ds-toggle-switch',
})
export class ToggleSwitch implements ComponentInterface {
	@Prop() focusable = true;
	@Prop() labelOn = 'ON';
	@Prop() labelOff = 'OFF';
	@Prop() toggleOnLinkEvent = 'ESG-Toggle-on';
	@Prop() toggleOffLinkEvent = 'ESG-Toggle-off';
	@Prop({ reflect: true, mutable: true }) on = false;
	@Prop() accessibilityLabelledby: string;
	@Prop() defaultChecked = false;

	@Event() toggleSwitch: EventEmitter<{ on: boolean }>;

	@Method()
	async toggle() {
		this.on = !this.on;
		this.toggleSwitch.emit({
			on: this.on,
		});
	}

	@Listen('click')
	clickHandler(event: MouseEvent) {
		event.stopPropagation();
		this.toggle();
	}

	componentWillLoad() {
		if (this.defaultChecked) {
			this.on = this.defaultChecked;
		}
	}

	renderContents(): string[] {
		return [
			<span class="ds-toggle-knob" />,
			<span
				class="ds-toggle-switch-label ds-eyebrow-xs"
				aria-hidden="true"
				data-link-event={
					this.on ? this.toggleOnLinkEvent : this.toggleOffLinkEvent
				}
			>
				{this.on ? this.labelOn : this.labelOff}
			</span>,
		];
	}

	render(): string {
		if (this.focusable) {
			const props = {
				'aria-labelledby': this.accessibilityLabelledby,
			};

			return (
				<button
					role="switch"
					aria-checked={this.on ? 'true' : 'false'}
					{...props}
				>
					{this.renderContents()}
				</button>
			);
		} else {
			return <div class="ds-emulated-button">{this.renderContents()}</div>;
		}
	}
}
